import { ClaimDocumentDeleteUseCase } from '../../../application';

export default class ClaimDocumentDeleteService {
    constructor() {}

    async execute(event) {
        const request = await ClaimDocumentDeleteUseCase(event);

        return request;
    }
}
